import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AuthQueryOptions, BOOKMARK_TYPE } from '@/api';
import { NewsCard } from '@/components/molecule/NewsCard';
import { ROUTES } from '@/constants';
import { useBookmark } from '@/hooks/useBookmark';
import { buildDetailSlug } from '@/utils/detailSlug';
import { EmptyScrapList } from './EmptyScrapList';
export const HometownNewsScrapList = () => {
  const $ = _c(12);
  const {
    bookmark
  } = useBookmark();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/member/wishlist/hometown-news"](),
      select: _temp,
      placeholderData: keepPreviousData
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: hometownNewsScrap
  } = useQuery(t0);
  if (!hometownNewsScrap?.totalCount) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyScrapList />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== hometownNewsScrap.totalCount) {
    t1 = <p className="px-20 py-10 font-500 text-Gray-black typo-body4">총 {hometownNewsScrap.totalCount}개</p>;
    $[2] = hometownNewsScrap.totalCount;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== bookmark || $[5] !== hometownNewsScrap.contents) {
    t2 = hometownNewsScrap?.contents?.map(news => <li key={news.hometownNewsId}><NewsCard id={news.hometownNewsId} daysAgo={news.daysAgo} imageSrc={news.thumbnail} isBookmarked={news.wishlistYN} link={ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
        idIdx: buildDetailSlug(news.hometownNewsIdIdx, news.hometownNewsName, news.slugId)
      })} title={news.hometownNewsName} onClickBookmark={() => {
        bookmark({
          bookmarkType: BOOKMARK_TYPE.HOMETOWN_NEWS,
          contentId: news.hometownNewsId,
          isBookmarked: news.wishlistYN,
          idx: news.hometownNewsIdIdx,
          contentName: news.hometownNewsName,
          policyAgency: news.agency
        });
      }} /></li>);
    $[4] = bookmark;
    $[5] = hometownNewsScrap.contents;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <ul className="flex flex-col gap-16">{t2}</ul>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <article className="flex flex-col">{t1}{t3}</article>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}